const ProfileIcon = ({ ...props }) => {
  const color = props?.color || "#05383f";
  const size = props?.size || "30px";
  const fileSrc = "/public/icon/profile.svg";
  return (
    <div
      id="btn-admin-menus"
      style={{
        width: size,
        height: size,
        marginLeft: "10px",
        display: "inline-block",
        verticalAlign: "middle",
        backgroundColor: color,
        maskImage: "url(" + fileSrc + ")",
        maskSize: "contain",
        WebkitMaskImage: "url(" + fileSrc + ")",
        WebkitMaskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
      }}
    />
  );
};

export default ProfileIcon;
